import {useEffect, useState} from "react";
import Loading from "../../component/Loading/Loading";
import {getAllTransactions} from "./functions";
import {PickDateTime, PickDateTimeWithoutContainer} from "../../component/PickDate/PickDate";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowDown, faArrowUp, faPencil, faTrash} from "@fortawesome/free-solid-svg-icons";
import {Link, useLocation, useSearchParams} from "react-router-dom";
import {
    getBillAmountWithoutDiscount,
    getBillDiscountAmount,
    getBillPayableAmount,
    getBillPayedAmount
} from "../Orders/functions";
import TransactionFilter from "./component/TransactionFilter";

const Transactions = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [allTransactions, setAllTransactions] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const location = useLocation();

    useEffect(() => {
        (async () => {
            document.title = "تراکنش های مالی";
            const allTransactions = await getAllTransactions(location.search);
            console.log(allTransactions);
            setAllTransactions(allTransactions);
            setIsLoading(false);
        })();

    }, [searchParams]);

    if (isLoading)
        return <Loading/>

    let increaseAmount = 0;
    let decreaseAmount = 0;
    for (let i = 0; i < allTransactions.length; i++) {
        if (allTransactions[i].type == "INCREASE"){
            increaseAmount += allTransactions[i].amount;
        }else if (allTransactions[i].type == "DECREASE"){
            decreaseAmount += allTransactions[i].amount;
        }
    }
    const totalAmount = increaseAmount - decreaseAmount;

    return (
        <div className="container-fluid p-0">
            <div className="mb-4">
                <h1 className="h3 d-inline align-middle">تراکنش های مالی</h1>
            </div>

            <div className="row">
                <div className="card">
                    <div className="card-body">
                        <TransactionFilter searchParams={Object.fromEntries([...searchParams])} onSubmit={async (value) => {
                            const newSearchParams = {...Object.fromEntries([...searchParams])  , ...value , page : 1 };
                            setSearchParams(newSearchParams)
                        }} />
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="card">
                    <div className="card-body">
                        <div className="table-responsive">
                            <table className={"table text-center"}>
                                <thead>
                                <tr>
                                    <th width={"5%"}>ردیف</th>
                                    <th width={"5%"}>آیدی</th>
                                    <th>کاربر</th>
                                    <th width={"15%"}>ساعت تراکنش</th>
                                    <th>توضیح</th>
                                    <th width={"10%"}>نوع تراکنش</th>
                                    <th>مبلغ</th>
                                    <th>ثبت کننده</th>
                                    <th>وضعیت</th>
                                    <th width={"5%"}></th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    allTransactions.map((transaction, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>
                                                    {transaction.id || <span>#{transaction.billId}</span>
                                                    }
                                                </td>
                                                <td>{transaction.person.firstname + " " + transaction.person.lastname}</td>
                                                <td>
                                                    <PickDateTimeWithoutContainer timestamp={transaction.timestamp}
                                                                                  disabled={true}/>
                                                </td>
                                                <td>{transaction.description}</td>
                                                <td>
                                                    {transaction.type == "INCREASE" && <span className={"text-success"}>
                                                    <FontAwesomeIcon icon={faArrowUp} className={"ms-1"}/>
                                                    افزایشی
                                                </span>}
                                                    {transaction.type == "DECREASE" && <span className={"text-danger"}>
                                                    <FontAwesomeIcon icon={faArrowDown} className={"ms-1"}/>
                                                    کاهشی</span>}
                                                </td>

                                                <td>{transaction.amount ? transaction.amount.toLocaleString() : 0}</td>
                                                <td>
                                                    {transaction.managerId && (transaction.manager.person.firstname + " " + transaction.manager.person.lastname + " ")}
                                                    {!transaction.managerId && <span>سیستمی</span>}
                                                </td>
                                                <td>
                                                    {(transaction.status.status == "VERIFIED" || transaction.status.status == "PAYED") &&
                                                        <span className={"text-success"}>تایید شده</span>}
                                                    {transaction.status.status != "VERIFIED" && transaction.status.status != "PAYED" &&
                                                        <span className={"text-danger"}>تایید نشده</span>}
                                                </td>
                                                <td>
                                                    <td>
                                                        <Link
                                                            to={`${transaction.billId ? `../orders/update/${transaction.billId}` : `update/${transaction.id}`}`}>
                                                            <FontAwesomeIcon className={"btn"} icon={faPencil}
                                                                             width={20}/>
                                                        </Link>
                                                    </td>
                                                </td>
                                            </tr>
                                        );
                                    })
                                }
                                </tbody>
                            </table>

                            <div className="col-md-4 col-sm-6 me-auto mt-4">
                            <table className={"table table-borderless table-hover text-center"}>
                                <tbody>
                                <tr className={"bg-success"}>
                                    <td className={"w-50 text-white"}>جمع تراکنش های افزایش</td>
                                    <td className={"w-50 text-white"}>{increaseAmount.toLocaleString()}</td>
                                </tr>
                                <tr className={"bg-danger"}>
                                    <td className={"w-50 text-white"}>جمع تراکنش های کاهش</td>
                                    <td className={"w-50 text-white"}>{decreaseAmount.toLocaleString()}</td>
                                </tr>

                                {
                                    totalAmount == 0 && <tr className={"bg-success"}>
                                        <td className={"text-white"} colSpan={2}>تسویه</td>
                                    </tr>
                                }

                                {
                                    totalAmount > 0 && <tr className={"bg-success"}>
                                        <td className={"w-50 text-white"}>جمع کل</td>
                                        <td className={"w-50 text-white"}>{totalAmount.toLocaleString()} بستکار</td>
                                    </tr>
                                }

                                {
                                    totalAmount < 0 && <tr className={"bg-danger"}>
                                        <td className={"w-50 text-white"}>جمع کل</td>
                                        <td className={"w-50 text-white"}>{totalAmount.toLocaleString()} بدهکار</td>
                                    </tr>
                                }


                                </tbody>
                            </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    )
}

export default Transactions;